import { Component, input } from '@angular/core';
import { ButtonDirective } from 'primeng/button';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-nav-bar-button',
  template: `
    <button
      pButton
      class="p-button-text"
      [label]="label()"
      [icon]="icon()"
      [routerLink]="routerLink()"
    ></button>
  `,
  styles: [`
    .p-button.p-button-text:enabled:hover {
      background: var(--p-primary-200);
    }
  `],
  standalone: true,
  imports: [ButtonDirective, RouterLink],
})
export class NavBarButtonComponent {
  label = input.required<string>();
  routerLink = input.required<string>();
  icon = input('');
}
